import React from 'react';
import { Icon } from '@/presentation/components';

const ButtonFloating = () => {
  const irAlInicio = () => {
    const modalScrollable = document.getElementById('modal-scrollable-content');
    if (modalScrollable) {
      modalScrollable.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return (
    <button
      type="button"
      style={{
        position: 'fixed',
        bottom: '80px',
        right: '16px',
        width: '48px',
        height: '48px',
        backgroundColor: '#5B36F2',
        border: 'none',
        boxShadow: '0px 4px 10px rgba(0,0,0,0.3)',
        cursor: 'pointer',
        zIndex: 2000,
        padding: '12px',
        borderRadius: '4px'
      }}
      onClick={irAlInicio}
    >
      <Icon name="chevron-up" size={24} color="#ffffff" />
    </button>
  );
};

export default ButtonFloating;
